import React from "react"
import { usePresence } from "./use-presence"
import { useOnlineUsers } from "./presence-store"

export function PresenceTracker({ user }) {
  usePresence(user)

  return window.__debugPresence ? <PresenceDebugger /> : null
}

function PresenceDebugger() {
  const onlineUsers = useOnlineUsers()

  debugLog(onlineUsers)

  return null
}

/* eslint-disable no-console */
function debugLog(onlineUsers) {
  console.groupCollapsed("Presence tracker")
  // Log presence data in a readable format for debugging
  if (onlineUsers.length > 0) {
    console.log(`🟢 ${onlineUsers.length} user(s) online:`)

    onlineUsers.forEach(user => {
      const tabCount = Object.keys(user.tabs).length
      const activeTab = Object.values(user.tabs).find(tab => tab.isActive)
      const currentPage = activeTab?.page || "unknown"

      console.log(`  👤 ${user.name} (${user.email}) - ${tabCount} tab(s)`)
      console.log(`     Currently on: ${currentPage}`)
    })

    // Show detailed tab info in table format
    const tabData = []
    onlineUsers.forEach(user => {
      Object.entries(user.tabs).forEach(([sessionId, tab]) => {
        tabData.push({
          SessionId: sessionId,
          User: user.name,
          Page: tab.page,
          Title:
            tab.title?.substring(0, 30) + (tab.title?.length > 30 ? "..." : ""),
          Active: tab.isActive ? "✅" : "❌",
          "Last Seen": new Date(tab.lastSeen).toLocaleTimeString()
        })
      })
    })

    if (tabData.length > 0) {
      console.table(tabData)
    }
  } else {
    console.log("👻 No other users online")
  }
  console.groupEnd()
}
/* eslint-enable no-console */
